// extracted by mini-css-extract-plugin
export default {"top_div":"CompanyInfoScreen_top_div__vx1tv"};